module.exports = __webpack_public_path__ + "assets/img/free_15.46b2df91.png";